import React, { useRef, useState } from 'react';

import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import api from '~/services/api';

import {
  Video,
  Container,
  Content,
  ButtonContainer,
  CustomButton,
  Title,
  PreviewContainer,
  ImagePreview,
  ProgressContainer,
  ProgressBar,
  ContainerCabecalho,
  TableCabecalho,
  ThCabecalho,
  TdCabecalho,
  TrCabecalho,
} from './styles';

export default function CameraUploadMultiple({ id, token, data }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [photos, setPhotos] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [telaAtual, setTelaAtual] = useState('telaPrincipal');

  const [photoFrente, setPhotoFrente] = useState(null);
  const [photoVerso, setPhotoVerso] = useState(null);

  const mudarTela = (novaTela) => {
    setTelaAtual(novaTela);
  };

  const confirmaPhotoFrente = () => {
    setPhotoFrente('fotoFrente');
    handleTelaTirarFotoVerso();
    setUploadProgress(0);
  };

  const confirmaPhotoVerso = () => {
    setPhotoVerso('fotoVerso');
    setTelaAtual('telaPrincipal');
  };

  const limpaPhotos = () => {
    setPhotoFrente(null);
    setPhotoVerso(null);
    setPhotos([]);
  };

  const reiniciarPhotos = () => {
    limpaPhotos();
    stopCamera();
    setTelaAtual('telaPrincipal');
    setUploadProgress(0);
  };

  const reiniciarPhotosSemStopCamera = () => {
    limpaPhotos();
    setTelaAtual('telaPrincipal');
  };

  const handleTelaTirarFotoFrente = async () => {
    mudarTela('telaTirarFotoFrente');
    await startCamera();
  };

  const handleTelaTirarFotoFrenteNovamente = async () => {
    mudarTela('telaTirarFotoFrente');
    await startCamera();
    setPhotoFrente(null);
    setPhotoVerso(null);
    setPhotos([]);
  };

  const handleTelaCapturePhotoFrente = async () => {
    mudarTela('telaConfirmarFotoFrente');
    capturePhoto();
    stopCamera();
  };

  const handleTelaTirarFotoVerso = async () => {
    mudarTela('telaTirarFotoVerso');
    await startCamera();
  };

  const handleTelaTirarFotoVersoNovamente = async () => {
    mudarTela('telaTirarFotoVerso');
    await startCamera();
    setPhotoVerso(null);
    setPhotos((prevItems) => prevItems.filter((_, index) => index !== 1));
  };

  const handleTelaCapturePhotoVerso = async () => {
    mudarTela('telaConfirmarFotoVerso');
    capturePhoto();
    stopCamera();
  };

  const handleEnviarUpload = async () => {
    mudarTela('telaEnviandoNotas');
    handleUpload();
  };

  // Inicia a câmera
  const startCamera = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      alert('Sua API getUserMedia não é suportada neste navegador.');
      return;
    }
    try {
      let stream = null;

      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1920 }, // ou exact, min, max
            height: { ideal: 1080 },
            facingMode: { ideal: 'environment' },
          },
          // video: { facingMode: { exact: "environment" } }
        });
      } catch (error) {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
      }

      const track = stream.getVideoTracks()[0];
      const settings = track.getSettings();
      console.log(
        'Resolução real da câmera:',
        settings.width,
        'x',
        settings.height
      );
      const capabilities = track.getCapabilities();

      console.log('Capacidades da câmera:', capabilities);

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error('Erro ao acessar a câmera:', error);
      alert('Não foi possível acessar a câmera.');
    }
  };

  // Captura a foto (limitado a 2)
  const capturePhoto = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageDataURL = canvas.toDataURL('image/jpeg', 1.0);
      // const imageDataURL = canvas.toDataURL("image/png");

      if (photos.length < 2) {
        setPhotos([...photos, imageDataURL]);
      } else {
        alert('Você já capturou 2 fotos.');
      }
    } else {
      alert('Você deve iniciar a camera primeiro.');
    }
  };

  // Encerra a câmera
  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    } else {
      alert('Você deve iniciar a camera primeiro.');
    }
  };

  // Converte Data URL para Blob
  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleDeletar = () => {
    if (photos.length > 0) {
      setPhotos([]);
    } else {
      alert('Você não capturou fotos.');
    }
  };

  // Envia as fotos capturadas para o backend com progress bar
  const handleUpload = async () => {
    if (photos.length === 0) {
      alert('Nenhuma foto capturada!');
      return;
    }

    const formData = new FormData();

    photos.forEach((photo, index) => {
      const blob = dataURLtoBlob(photo);
      const file = new File(
        [blob],
        `notafiscal_captured_${data.nfdescarganf}_${index + 1}.jpg`,
        { type: blob.type }
      );
      formData.append(`imagem${index + 1}`, file);
    });

    formData.append('tokenuuiddescarganf', id);

    try {
      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      const response = await api.post('fotosnf/multiples', formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
        headers,
      });

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 202
      ) {
        alert('Fotos enviadas com sucesso!');
        setUploadProgress(0);
        handleDeletar();
        setTelaAtual('telaEnvioConcluidoComExito');
      } else {
        alert('Erro ao enviar as fotos!');
        setUploadProgress(0);
        setTelaAtual('telaPrincipal');
      }
    } catch (error) {
      alert(`Erro ao enviar as fotos! ${error}`);
      setUploadProgress(0);
      setTelaAtual('telaPrincipal');
    }
  };

  return (
    <Container>
      <Title>SCA+ Capturar Fotos</Title>

      <ContainerCabecalho>
        <TextField
          value={data.nfdescarganf}
          label="Nota Fiscal"
          variant="outlined"
          disabled
          fullWidth
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          value={data.dataemissaonfdescarganf}
          label="Data de Emissão"
          variant="outlined"
          fullWidth
          disabled
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          value={data.volumenfdescarganf}
          label="Volume"
          variant="outlined"
          fullWidth
          disabled
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </ContainerCabecalho>

      <Content>
        <canvas ref={canvasRef} style={{ display: 'none' }} />

        {telaAtual === 'telaPrincipal' && (
          <PreviewContainer>
            {photos.length > 0 ? <h3>Fotos capturadas:</h3> : ''}

            {photos.length > 0
              ? photos.map((photo, index) => (
                  <>
                    <ImagePreview
                      key={index}
                      src={photo}
                      alt={`Foto ${index + 1}`}
                    />
                    <br />
                  </>
                ))
              : ''}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </PreviewContainer>
        )}

        {telaAtual === 'telaTirarFotoFrente' && (
          <>
            {/* <h1>Tela Tirar Foto Frente</h1> */}
            <Video ref={videoRef} autoPlay />
          </>
        )}

        {telaAtual === 'telaConfirmarFotoFrente' && (
          <>
            {/* <h1>Tela Confirmar Foto Frente</h1> */}
            <PreviewContainer>
              <h3>Foto capturada frente:</h3>
              {photos.length > 0 ? (
                <ImagePreview key={0} src={photos[0]} alt={`Foto ${1}`} />
              ) : (
                <p>Nenhuma foto capturada.</p>
              )}
            </PreviewContainer>
          </>
        )}

        {telaAtual === 'telaTirarFotoVerso' && (
          <>
            {/* <h1>Tela Tirar Foto Verso</h1> */}
            <Video ref={videoRef} autoPlay />
          </>
        )}

        {telaAtual === 'telaConfirmarFotoVerso' && (
          <>
            {/* <h1>Tela Confirmar Foto Verso</h1> */}
            <PreviewContainer>
              <h3>Foto capturada verso:</h3>
              {photos.length > 0 ? (
                <ImagePreview key={1} src={photos[1]} alt={`Foto ${2}`} />
              ) : (
                <p>Nenhuma foto capturada.</p>
              )}
            </PreviewContainer>
          </>
        )}

        {telaAtual === 'telaEnviandoNotas' && (
          <PreviewContainer>
            {uploadProgress < 100 && (
              <h3>
                <p>Progresso: {uploadProgress} %</p>
              </h3>
            )}

            {uploadProgress > 99 && <h3>Envio concluido!</h3>}
          </PreviewContainer>
        )}

        {telaAtual === 'telaEnvioConcluidoComExito' && (
          <PreviewContainer>
            <h3>Envio concluido!</h3>
          </PreviewContainer>
        )}
      </Content>

      <ButtonContainer>
        {telaAtual === 'telaPrincipal' && (
          <>
            {!photoFrente && (
              // <CustomButton onClick={() => mudarTela("telaTirarFotoFrente")}>
              <CustomButton
                color="primary"
                variant="outlined"
                onClick={() => handleTelaTirarFotoFrente()}
              >
                Tirar foto frente da nota fiscal
              </CustomButton>
            )}

            {photoFrente && photoVerso && (
              <>
                <CustomButton
                  color="primary"
                  variant="outlined"
                  onClick={() => handleEnviarUpload()}
                >
                  Enviar fotos
                </CustomButton>
                <CustomButton
                  color="secondary"
                  variant="outlined"
                  onClick={() => reiniciarPhotosSemStopCamera()}
                >
                  Reiniciar processo na tela principal
                </CustomButton>
              </>
            )}
          </>
        )}

        {telaAtual === 'telaTirarFotoFrente' && (
          <>
            {/* <CustomButton onClick={() => mudarTela("telaConfirmarFotoFrente")}> */}
            <CustomButton
              color="primary"
              variant="outlined"
              onClick={() => handleTelaCapturePhotoFrente()}
            >
              Clique para tirar a foto de frente
            </CustomButton>
            {/* <CustomButton onClick={() => setTelaAtual("telaPrincipal")}> */}
            <CustomButton
              color="secondary"
              variant="outlined"
              onClick={() => reiniciarPhotos()}
            >
              Voltar para tela principal
            </CustomButton>
          </>
        )}

        {telaAtual === 'telaConfirmarFotoFrente' && (
          <>
            <CustomButton
              color="primary"
              variant="outlined"
              onClick={() => confirmaPhotoFrente()}
            >
              {/* <CustomButton onClick={() => mudarTela("telaPrincipal")}> */}
              Confirmar foto
            </CustomButton>
            {/* <CustomButton onClick={() => setTelaAtual("telaTirarFotoFrente")}> */}
            <CustomButton
              color="secondary"
              variant="outlined"
              onClick={() => handleTelaTirarFotoFrenteNovamente()}
            >
              Voltar para tirar foto frente da nota fiscal
            </CustomButton>
          </>
        )}

        {telaAtual === 'telaTirarFotoVerso' && (
          <>
            {/* <CustomButton onClick={() => mudarTela("telaConfirmarFotoVerso")}> */}
            <CustomButton
              color="primary"
              variant="outlined"
              onClick={() => handleTelaCapturePhotoVerso()}
            >
              Tirar foto verso da nota fiscal
            </CustomButton>
            {/* <CustomButton onClick={() => setTelaAtual("telaPrincipal")}> */}
            <CustomButton
              color="secondary"
              variant="outlined"
              onClick={() => reiniciarPhotos()}
            >
              Voltar para tela principal
            </CustomButton>
          </>
        )}

        {telaAtual === 'telaConfirmarFotoVerso' && (
          <>
            <CustomButton
              color="primary"
              variant="outlined"
              onClick={() => confirmaPhotoVerso()}
            >
              Confirmar foto
            </CustomButton>
            {/* <CustomButton onClick={() => setTelaAtual("telaTirarFotoVerso")}> */}
            <CustomButton
              color="secondary"
              variant="outlined"
              onClick={() => handleTelaTirarFotoVersoNovamente()}
            >
              Voltar para tirar foto verso da nota fiscal
            </CustomButton>
          </>
        )}

        {telaAtual === 'telaEnviandoNotas' && (
          <>
            {uploadProgress > 0 && (
              <ProgressContainer>
                <p>Progresso: {uploadProgress}%</p>
                <ProgressBar value={uploadProgress} max="100" />
              </ProgressContainer>
            )}
          </>
        )}
      </ButtonContainer>
    </Container>
  );
}

CameraUploadMultiple.propTypes = {
  id: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

CameraUploadMultiple.defaultProps = {
  data: {},
};
